/* Tiện ích giao diện — tách từ app v4: $, esc, fmt, log, dialog, beep, flash, chẩn đoán */

export const $ = (s) => document.querySelector(s);
export const $$ = (s) => Array.from(document.querySelectorAll(s));

export function esc(s) {
  return String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
}
export function fmt(n) { return Number(n || 0).toLocaleString('vi-VN'); }
export function stamp() {
  const d = new Date(), p = (x) => String(x).padStart(2, '0');
  return p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds());
}
export function todayISO() {
  const d = new Date(), p = (x) => String(x).padStart(2, '0');
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
}
/* ISO timestamptz → 'YYYY-MM-DD' theo giờ máy (kho ở VN) */
export function dayOf(iso) {
  if (!iso) return '';
  const d = new Date(iso), p = (x) => String(x).padStart(2, '0');
  if (isNaN(d)) return '';
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
}
export function vnTime(iso) {
  if (!iso) return '';
  const d = new Date(iso); return isNaN(d) ? '' : d.toLocaleString('vi-VN');
}

/* ---------- chẩn đoán ---------- */
export const DIAG = { started: new Date().toISOString(), lines: [], errors: [] };
export function diagPush(kind, msg) {
  DIAG.lines.push(new Date().toISOString().slice(11, 23) + ' [' + (kind || 'info') + '] ' + msg);
  if (DIAG.lines.length > 800) DIAG.lines.splice(0, DIAG.lines.length - 800);
}
export function diagErr(where, e) {
  DIAG.errors.push({
    t: new Date().toISOString(), where,
    name: (e && e.name) || '', msg: (e && e.message) || String(e), stack: (e && e.stack) || ''
  });
  const el = $('#errNote');
  if (el) el.innerHTML = '<span style="color:var(--bad)">' + DIAG.errors.length + ' lỗi đã ghi nhận</span>';
}
window.addEventListener('error', (ev) => {
  diagErr('window.onerror', ev.error || { name: 'Error', message: ev.message, stack: ev.filename + ':' + ev.lineno });
  try { log('Lỗi JS: ' + (ev.message || '') + ' (dòng ' + ev.lineno + ')', 'er'); } catch (x) { }
});
window.addEventListener('unhandledrejection', (ev) => {
  diagErr('unhandledrejection', ev.reason);
  try { log('Lỗi bất đồng bộ: ' + ((ev.reason && ev.reason.message) || ev.reason), 'er'); } catch (x) { }
});

export function log(msg, cls) {
  try { diagPush(cls, String(msg).replace(/<[^>]+>/g, '')); } catch (e) { }
  const el = $('#log'); if (!el) return;
  const d = document.createElement('div');
  d.innerHTML = '<span class="t">' + stamp() + '</span>  <span class="' + (cls || '') + '">' + esc(msg) + '</span>';
  el.appendChild(d); el.scrollTop = el.scrollHeight;
}

/* ---------- modal ---------- */
export function dialog(opt) {
  return new Promise((res) => {
    $('#mTitle').textContent = opt.title || 'Xác nhận';
    $('#mBody').innerHTML = opt.body || '';
    $('#mExtra').innerHTML = opt.extra || '';
    const box = $('#mBtns'); box.innerHTML = '';
    const inp = $('#mExtra input');
    (opt.buttons || []).forEach((b) => {
      const el = document.createElement('button');
      el.className = 'btn ' + (b.cls || 'gho'); el.textContent = b.label;
      el.onclick = () => {
        if (b.check && inp && inp.value.trim().toUpperCase() !== inp.dataset.need) { inp.style.borderColor = 'var(--bad)'; inp.focus(); return; }
        $('#mask').classList.remove('on'); res(b.val);
      };
      box.appendChild(el);
    });
    $('#mask').classList.add('on');
    setTimeout(() => { const f = inp || box.lastChild; if (f && f.focus) f.focus(); }, 60);
  });
}
export function ask(title, body, extraHTML, yesLabel) {
  return dialog({
    title, body, extra: extraHTML, buttons: [
      { label: 'Hủy', val: false },
      { label: yesLabel || 'Xác nhận', val: true, cls: 'dang', check: !!extraHTML }
    ]
  });
}

/* ---------- âm thanh + nháy màn hình (giữ nguyên 5 nhịp của v4) ---------- */
export const SOUND = { on: true };
let actx = null;
export function beep(kind) {
  if (!SOUND.on) return;
  try {
    const AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
    actx = actx || new AC();
    const t = actx.currentTime, o = actx.createOscillator(), g = actx.createGain();
    o.connect(g); g.connect(actx.destination);
    if (kind === 'ok') {
      o.type = 'sine'; o.frequency.setValueAtTime(920, t);
      g.gain.setValueAtTime(.09, t); o.start(t); o.stop(t + .12);
    } else if (kind === 'done') {
      o.type = 'sine'; o.frequency.setValueAtTime(760, t); o.frequency.setValueAtTime(1140, t + .1);
      g.gain.setValueAtTime(.09, t); o.start(t); o.stop(t + .24);
    } else if (kind === 'dup') {
      o.type = 'square'; o.frequency.setValueAtTime(210, t);
      g.gain.setValueAtTime(.07, t); g.gain.setValueAtTime(0, t + .15);
      g.gain.setValueAtTime(.07, t + .26); g.gain.setValueAtTime(0, t + .41);
      o.start(t); o.stop(t + .42);
    } else if (kind === 'warn') {
      o.type = 'triangle'; o.frequency.setValueAtTime(660, t);
      g.gain.setValueAtTime(.085, t); g.gain.setValueAtTime(0, t + .09);
      g.gain.setValueAtTime(.085, t + .17); g.gain.setValueAtTime(0, t + .26);
      g.gain.setValueAtTime(.085, t + .34); g.gain.setValueAtTime(0, t + .43);
      o.start(t); o.stop(t + .44);
    } else {
      o.type = 'square'; o.frequency.setValueAtTime(190, t);
      g.gain.setValueAtTime(.07, t); o.start(t); o.stop(t + .34);
    }
  } catch (e) { }
}
export function flash(cls) {
  const f = $('#flash'); f.className = 'flash ' + cls;
  setTimeout(() => { f.className = 'flash'; }, 240);
}

/* ---------- IndexedDB kv (nhớ thư mục, âm thanh, người giao) ---------- */
function idb() {
  return new Promise((res, rej) => {
    const r = indexedDB.open('konni-kho', 1);
    r.onupgradeneeded = () => { r.result.createObjectStore('kv'); };
    r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error);
  });
}
export async function kvSet(k, v) { const db = await idb(); return new Promise((res, rej) => { const t = db.transaction('kv', 'readwrite'); t.objectStore('kv').put(v, k); t.oncomplete = () => res(); t.onerror = () => rej(t.error); }); }
export async function kvGet(k) { const db = await idb(); return new Promise((res, rej) => { const t = db.transaction('kv', 'readonly'), q = t.objectStore('kv').get(k); q.onsuccess = () => res(q.result); q.onerror = () => rej(q.error); }); }
export async function kvDel(k) { const db = await idb(); return new Promise((res) => { const t = db.transaction('kv', 'readwrite'); t.objectStore('kv').delete(k); t.oncomplete = () => res(); }); }

export function downloadText(name, text) {
  const b = new Blob([text], { type: 'text/plain;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(b); a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 4000);
}
